// File: app.module.ts
// Author: Joseph M Diaz
// Date: 4/20/2017
// Desc: Root module for the app.
// Other Contributors: Brandon Shreve

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { AuthenticationService } from './auth.service';
import { HomeComponent } from './home/home.component';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { CgpModule } from './shared/cgp.module';
import { ToastrModule } from 'ngx-toastr';
import { NumberOnlyDirective } from './shared/directives/numbers.directive';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { VEModule } from './components/ve/ve.module';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { EditorModule } from '@progress/kendo-angular-editor';
import { HttpClientModule } from '@angular/common/http';
import { CgpBroadcastMessageModule } from 'cgp-broadcast-message';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        MatToolbarModule,
        MatSidenavModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        ToastrModule.forRoot(),
        CgpModule,
        LayoutModule,
        TooltipModule,
        VEModule,
        SchedulerModule,
        EditorModule,
        CgpBroadcastMessageModule,
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        LoggedOutComponent,
        NotFoundComponent,
        NumberOnlyDirective,
    ],
    providers: [
        AppService,
        AuthenticationService,
        HttpClientModule
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
